import { useTranslation } from "react-i18next";
import { Gamepad2, Pause } from "lucide-react";
import { cn } from "@/lib/utils";
import { useGamesPortal } from "../hooks/use-games-portal";

export const GamesPipCard = () => {
  const { t } = useTranslation();
  const {
    selectedGame,
    view,
    sessionHud,
    panelSide,
    restorePanel,
  } = useGamesPortal();

  const title =
    view === "playing" && selectedGame
      ? t(selectedGame.name)
      : t("games.menuTitle");

  const handleOpen = () => {
    restorePanel();
  };

  return (
    <button
      type="button"
      onClick={handleOpen}
      title={t("games.pip.expand")}
      className={cn(
        "fixed bottom-[max(1.25rem,env(safe-area-inset-bottom))] z-[1] flex min-w-[188px] max-w-[240px] items-center gap-3 rounded-2xl border px-3 py-2.5 text-left shadow-2xl pointer-events-auto transition-all duration-200",
        panelSide === "left" ? "left-5" : "right-5",
        "border-border-secondary bg-bg-primary/95 text-text-primary backdrop-blur-xl",
        "hover:border-cyan-400/40 hover:shadow-cyan-500/10",
        "dark:border-gray-700 dark:bg-gray-900/95 dark:text-gray-100"
      )}
    >
      <div className="flex h-10 w-10 shrink-0 items-center justify-center rounded-xl bg-bg-tertiary dark:bg-gray-800">
        {sessionHud?.status === "paused" ? (
          <Pause className="h-4 w-4 text-cyan-500 dark:text-cyan-300" />
        ) : (
          <Gamepad2 className="h-4 w-4 text-text-secondary dark:text-gray-200" />
        )}
      </div>
      <div className="min-w-0 flex-1">
        <p className="truncate text-sm font-semibold text-text-primary dark:text-white">
          {title}
        </p>
        {sessionHud ? (
          <p className="mt-0.5 truncate text-xs text-text-tertiary-600 dark:text-gray-400">
            {t("games.tetris.score")}: {sessionHud.score}
            <span className="mx-1.5 text-border-secondary dark:text-gray-600">
              ·
            </span>
            {t("games.tetris.level")} {sessionHud.level}
          </p>
        ) : (
          <p className="mt-0.5 truncate text-xs text-text-tertiary-600 dark:text-gray-400">
            {t("games.pip.tapToOpen")}
          </p>
        )}
        {sessionHud?.status === "paused" && (
          <p className="mt-0.5 text-[10px] font-medium uppercase tracking-wide text-cyan-600 dark:text-cyan-300">
            {t("games.pip.paused")}
          </p>
        )}
        {sessionHud?.status === "over" && (
          <p className="mt-0.5 text-[10px] font-medium uppercase tracking-wide text-rose-500 dark:text-rose-300">
            {t("games.tetris.gameOver")}
          </p>
        )}
      </div>
    </button>
  );
};
